// extracted by mini-css-extract-plugin
var _1 = "StarProgressStandard__starProgress--FhBGx";
export { _1 as "starProgress" }
